export enum blockEditorFileUpload {
    resource_media = 0
}